import { FETCH_CART_ERROR, FETCH_CART_REQUEST, FETCH_CART_SUCCESS } from '../constants/ActionTypes'
import type GenericAction from './types/genericAction.types'

export type FetchCartErrorAction = GenericAction<
    typeof FETCH_CART_ERROR | typeof FETCH_CART_REQUEST | typeof FETCH_CART_SUCCESS,
    { error: { message: string; response: { status: number } } }
>

type State = {
    message: string
    status: number
}

const fetchCartError = (state: State, action: FetchCartErrorAction) => {
    switch (action.type) {
        case FETCH_CART_ERROR:
            return {
                message: action.error.message,
                status: action.error.response?.status,
            }
        case FETCH_CART_REQUEST:
        case FETCH_CART_SUCCESS:
            return null
        default:
            return state
    }
}

export default fetchCartError
